<template>
  <div class="content">
    <div class="idx-banner">
      <div class="box">
        <swiper :options="swiperOption1" ref="mySwiper">
          <template v-for="(item, index) in banners">
            <swiper-slide>
             <template v-if="item.url!=''">
              <a :href="item.url ">
                <el-row>
                  <el-col :xs="24" :sm="13" :lg="16" class="el-right">
                    <div class="idx-banner-img"><img :src="item.picUrl" width="700" height="432" /></div>
                  </el-col>
                  <el-col :xs="24" :sm="11" :lg="8" class="">
                    <div class="idx-banner-txt">
                      <p>{{ item.title }}</p>
                    </div>
      <!--              <div class="idx-m-txt">
                      <p>{{ item.title }}</p>
                    </div> -->
                  </el-col>
                </el-row>
                </a>
              </template>

              <template v-if="item.url===''">
                 <el-row>
                   <el-col :xs="24" :sm="13" :lg="16" class="el-right">
                     <div class="idx-banner-img"><img :src="item.picUrl" width="700" height="432" /></div>
                   </el-col>
                   <el-col :xs="24" :sm="11" :lg="8" class="">
                     <div class="idx-banner-txt">
                       <p>{{ item.title }}</p>
                     </div>
                <!--     <div class="idx-m-txt">
                       <p>{{ item.title }}</p>
                     </div> -->
                   </el-col>
                 </el-row>
               </template>
            </swiper-slide>
          </template>

        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-next swp1 qjico arrow-right1"></div>
        <div class="swiper-button-prev swp1 qjico arrow-left1"></div>
      </div>
    </div>
    <div class="idx-trust">
      <el-row>
        <el-col :xs="12" :sm="8" :lg="6"><div class="item"><span class="qjico px-hong"></span>大的清洁服务行业资源底蕴</div></el-col>
        <el-col :xs="12" :sm="8" :lg="6"><div class="item">规<span class="qjico px-fan"></span>的清洁服务教学内容支持</div></el-col>
        <el-col :xs="12" :sm="8" :lg="6"><div class="item">国内外专家<span class="qjico px-xue"></span>者智库助力教学研究</div></el-col>
        <el-col :xs="12" :sm="8" :lg="6"><div class="item">与<span class="qjico px-yuan"></span>校合作，学习成果社会承认</div></el-col>
      </el-row>
    </div>
    <div class="idx-screen-banner" style="background-image:url(https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/idx-screen-banner.png)">
      <div class="box">
        <el-row>
          <el-col :xs="16" :sm="12" :lg="12">
            <div class="l-txt">
              <p class="p01">学历证书+技能提升+升职加薪</p>
              <p class="p02">弘范携手国开大学推出清洁服务职业晋升系统班</p>
            </div>
          </el-col>
          <el-col :xs="8" :sm="12" :lg="12">
            <div class="r-txt"><p class="p02">400-618-3958</p></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="idx-class-type">
      <div class="idx-common-hd">
        <h2 class="title">多种班型，职场深造选择灵活</h2>
        <p class="desc">不同基础不同班型，因材施教，分级教学</p>
      </div>
      <div class="class-type-box">
        <el-row :gutter="20">
          <el-col :xs="24" class="idx-col-lg-5">
            <a href="/paidCourses/9" target="_blank">
            <div class="item">
              <div class="hd">清洁高级技师班</div>
              <div class="bd">
                <p>清洁一线服务人员</p>
                <p>行业菜鸟</p>
              </div>
            </div>
            </a>
          </el-col>
          <el-col :xs="24" class="idx-col-lg-5">
            <a href="/paidCourses/7" target="_blank">
            <div class="item">
              <div class="hd">清洁服务培训师</div>
              <div class="bd">
                <p>培训岗位人员</p>
                <p>企业内训师</p>
              </div>
            </div>
            </a>
          </el-col>
          <el-col :xs="24" class="idx-col-lg-5">
            <a href="/paidCourses/8" target="_blank">
            <div class="item">
              <div class="hd">高级运营经理班</div>
              <div class="bd">
                <p>企业管理者</p>
                <p>项目经理</p>
              </div>
            </div>
            </a>
          </el-col>
          <el-col :xs="24" class="idx-col-lg-5">
            <a href="/paidCourses/10" target="_blank">
            <div class="item">
              <div class="hd">绿色标准清洁管理</div>
              <div class="bd">
                <p>企业管理者</p>
                <p>质检岗位人员</p>
              </div>
            </div>
            </a>
          </el-col>
          <el-col :xs="24" class="idx-col-lg-5">
            <a href="/paidCourses/11" target="_blank">
            <div class="item">
              <div class="hd">企业定制内训</div>
              <div class="bd">
                <p>清洁服务行业</p>
                <p>各层次人才</p>
              </div>
            </div>
            </a>
          </el-col>
          <el-col :xs="24" class="idx-col-lg-5">
            <a href="/paidCourses/16" target="_blank">
            <div class="item">
              <div class="hd">环境消杀专业班</div>
              <div class="bd">
                <p>医疗护工</p>
                <p>保洁从业者</p>
              </div>
            </div>
            </a>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--课程优势-->
    <div class="idx-course-advantage">
      <div class="idx-common-hd">
        <h2 class="title">课程优势</h2>
        <p class="desc">专业的清洁培训机构</p>
      </div>
      <div class="course-advantage-box">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :lg="12">
            <div class="item">
              <div class="hd">行业洞察</div>
              <div class="bd">深度的行业认知，涉及近20多个行业，近1200个案例</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <div class="item">
              <div class="hd">技术研究</div>
              <div class="bd">对清洁服务技术的深入研究和创新，帮助企业定制服务标准化方案</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <div class="item">
              <div class="hd">运营管理</div>
              <div class="bd">为物业、保洁公司提供管理人员业务提升服务，帮助企业进行人才梯队建设</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <div class="item">
              <div class="hd">师资力量</div>
              <div class="bd">与行业权威倒是咨询交流，关注成本、关注效率、关注方案落地</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
        <!--我们的课程-->
    <div class="idx-we-course">
         <div class="idx-common-hd">
           <h2 class="title">学员心声</h2>
           <p class="desc">受训学员经验分享</p>
         </div>
         <div class="we-course-box">

            <swiper :options="swiperOption2" ref="mySwiper">
              <template v-for="(item, index) in course">
                <swiper-slide>
                  <el-row :gutter="10">
                    <el-col :xs="24" :sm="13" :lg="16" class="">
                      <div class="course-b-img"><video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player></div>
                    </el-col>
                    <el-col :xs="24" :sm="11" :lg="8" class="">
                      <div class="course-b-txt">
                        <p class="title">{{ item.title }}</p>
                        <p class="desc" v-html="item.desc"></p>
                      </div>
                    </el-col>
                  </el-row>
                </swiper-slide>
              </template>
            </swiper>
            <div class="swiper-button-prev swp2 qjico arrow-left2"></div>
            <div class="swiper-button-next swp2 qjico arrow-right2"></div>

         </div>
    </div>

    <!--服务客户-->
    <div class="idx-service-customer">
      <div class="idx-common-hd">
        <h2 class="title">服务客户</h2>
        <p class="desc">为用户提供服务价值</p>
      </div>

      <div class="service-customer-box">
        <el-row :gutter="20">
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s01.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s02.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s03.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s04.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s05.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s06.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s07.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s08.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s09.png" width="240" height="135" /></div>
            </div>
          </el-col>
          <el-col :xs="12" class="idx-col-lg-5">
            <div class="item">
              <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/s10.png" width="240" height="135" /></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--组织-->
    <div class="idx-organization">
      <div class="organization-box">
        <el-row>
          <a :href="recOrganization.url" target="_blank">
          <el-col :xs="24" :sm="12" :lg="12">
            <div class="item" :style="{backgroundImage: 'url('+ recOrganization.picUrl+')'}">
              {{recOrganization.title}}
            </div>
          </el-col>
          </a>
          <a :href="recTravel.url" target="_blank">
          <el-col :xs="24" :sm="12" :lg="12">
            <div class="item" :style="{backgroundImage: 'url('+ recTravel.picUrl+')'}">
              {{recTravel.title}}
            </div>
          </el-col>
          </a>
        </el-row>
      </div>
    </div>

    <div class="idx-entered" style=" background:url(https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/hongfan.jpg) no-repeat center center fixed !important;">
       <div class="entered-box">
         <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/idx-txt.png"></div>
          <p class="txt">弘范智汇——二十年敬一事，只为开拓您的清洁从业之路</p>
          <div class="btn"><a href="/aboutUs#myform" target="_blank">预约报名</a></div>
       </div>
    </div>

  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
require('swiper/dist/css/swiper.css');

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption1: {
    /*    autoplay: {
        delay: 3000,
        }, */
      pagination: {
        el: '.swiper-pagination'
      },
        observer: true,
        observeParents: true,
        speed: 500,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next.swp1', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev.swp1' ,//后退按钮的css选择器或HTML元素。
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        }
      },
      swiperOption2: {
        observer: true,
        observeParents: true,
        speed: 500,
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.swp2', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev.swp2' ,//后退按钮的css选择器或HTML元素。
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        }
      },
      course: [
        {
          id: '11',
          url: 'https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/idx-course001.jpg',
          title:'第一期清洁服务培训师（CSTTT）提升班专访',
          desc: '清洁服务培训师（CSTTT）一期班在北京开班，作为第一期的学员，同学们分享了初识CSTTT课程的感受以及学习体验。<br/>实用的课堂讲课技巧和张红老师突出的清洁服务师道精神为学员们留下了深刻印象。'
        },
      ],

      path: domain.apiUrl,
      banner_code: 1,//banner code值
      organization_code: 6,//合作组织 code值
      travel_code: 7,//游学 code值

      banners: [],//banners
      recOrganization: {},//合作组织
      recTravel: {},//游学
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: 'video/mp4',
            //url地址
            src: "https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/video/caifang.mp4"
          }
        ],
        //你的封面地址
       poster: 'https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/video/fengmian.png',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }

      },
    };
  },
  created() {
    this.banner();
    this.travel();
    this.organization();
  },
  methods: {
    banner: function() {
      let formData = {};
      formData.code = this.banner_code;
      this.$http.get(this.path + '/recomModel/list',{params:formData}).then((response) => {
        if (response.status === 200) {
          var data = response.body;
          this.banners = data;
        }
      }, (response) => {
        this.$message.error("error")
      });
    },
    travel: function() {
      let formData = {};
      formData.code = this.travel_code;
      this.$http.get(this.path + '/recomModel/list',{params:formData}).then((response) => {
        if (response.status === 200) {
          var data = response.body;
          this.recTravel = data[0];
        }
      }, (response) => {
        this.$message.error("error")
      });
    },
    organization: function() {
      let formData = {};
      formData.code = this.organization_code;
      this.$http.get(this.path + '/recomModel/list',{params:formData}).then((response) => {
        if (response.status === 200) {
          var data = response.body;
          this.recOrganization = data[0];
        }
      }, (response) => {
        this.$message.error("error")
      });
    },
  },
};
</script>

<style lang="scss">
@import '../assets/css/index.scss';
</style>



// WEBPACK FOOTER //
// src/components/index.vue